import intlTelInput from 'intl-tel-input';
import {
  getStyleguideClasses,
  isMobile,
  validatePhoneNumber,
} from './index.js';

const getInitOptions = (defaultCountry, wrapperClass, form) => {
  const initialCountry = defaultCountry.toLowerCase();
  const options = {
    loadUtils: () => import('intl-tel-input/utils'),
    separateDialCode: true,
    placeholderNumberPolicy: 'OFF',
    initialCountry,
    countryOrder: [initialCountry],
    formatAsYouType: false,
  };
  if (isMobile()) {
    let dropdownContainer = `${wrapperClass}` + ' .phone__wrapper';
    if (form !== null) {
      const formId = form.el.getAttribute('id');
      dropdownContainer = `#${formId} ` + dropdownContainer;
    }

    options.dropdownParent = document.querySelector(dropdownContainer);
  }
  return options;
};

const getValidationErrorCode = (validationError) => {
  const validationErrorCodes = {
    IS_POSSIBLE: 0,
    INVALID_COUNTRY_CODE: 1,
    TOO_SHORT: 2,
    TOO_LONG: 3,
    IS_POSSIBLE_LOCAL_ONLY: 5,
    INVALID_LENGTH: 5,
  };

  return validationErrorCodes[validationError] ?? -99;
};

const preserveLegacyInstanceShape = (intlTelInputInstance, input) => {
  const getValidationError =
    intlTelInputInstance.getValidationError.bind(intlTelInputInstance);

  intlTelInputInstance.getValidationError = () =>
    getValidationErrorCode(getValidationError());
  intlTelInputInstance.selectedFlag = input
    .closest('.iti')
    ?.querySelector('.iti__selected-country');
};

function sanitizePhoneInput(phoneEl) {
  // Store current positions and value in variables
  const start = phoneEl.selectionStart;
  const end = phoneEl.selectionEnd;
  const inputValue = phoneEl.value;

  // Replace the first '00' with '+'
  phoneEl.value = phoneEl.value.replace(/^00/g, '+');

  // Keeps the pointer position
  if (inputValue.length > phoneEl.value.length) {
    phoneEl.setSelectionRange(start - 1, end - 1);
  }
}

function handleInputChange(e) {
  sanitizePhoneInput(e.target);
}

export const getIntlTelInputCountryData = () => intlTelInput.getAllCountries();

const initIntTelInput = ({
  input,
  locale,
  wrapperClass,
  validation = false,
  form = null,
}) => {
  if (!input) return;

  const intlTelInputInstance = intlTelInput(
    input,
    getInitOptions(locale, wrapperClass, form)
  );
  preserveLegacyInstanceShape(intlTelInputInstance, input);

  sanitizePhoneInput(input);
  input.addEventListener('change', handleInputChange);
  input.addEventListener('keyup', handleInputChange);

  if (validation) {
    form.submitButton.addEventListener('click', async (e) => {
      e.preventDefault();

      await intlTelInputInstance.promise;

      const inputValidation = validatePhoneNumber(
        intlTelInputInstance,
        input.value.trim(),
        false,
        $(form.el).find(wrapperClass)
      );

      if (inputValidation.isValid) {
        input.removeEventListener('change', handleInputChange);
        input.removeEventListener('keyup', handleInputChange);

        // Update input with the number and prefix on submit
        // The plugin doesn't do it automatically, to save the whole phone number
        input.value = intlTelInputInstance.getNumber();
        form.el.submit();
      } else {
        $(form.submitButton).removeClass(
          ...getStyleguideClasses(['btn--loading'])
        );
      }
    });
  }

  return intlTelInputInstance;
};

export default initIntTelInput;
